import { FormSection } from "components/MainSectionTemplate/types";
import { YesNoRadioGroupForInPageEditing, YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import React from "react";
import { DaysAfterDateInput, DaysAfterDateText } from "./DaysAfterDateRow";

interface Props {
  instruction: server.dto.UpdateClientConfigurationInstruction
}

export const QuoteSection = (props: Props): FormSection => {
  return {
    key: "quoteSettings",
    type: "regular",
    title: site.currentEnvironment.quote.singular,
    fields: [{
      key: "quote_enabled",
      label: RESX.EmbedWizard.Display,
      render: () => <YesNoText value={props.instruction.quoteEnabled} />,
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.quoteEnabled}
          onChange={(v) => onChange(v, true)}
        />,
        type: "custom",
        initialValue: props.instruction.quoteEnabled,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, quoteEnabled: value });
        }
      }
    },
    {
      key: "quote_costs",
      label: RESX.Financial.Costs,
      render: () => <YesNoText value={props.instruction.quoteDisplayCosts} />,
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.quoteDisplayCosts}
          onChange={(v) => onChange(v, true)}
        />,
        type: "custom",
        initialValue: props.instruction.quoteDisplayCosts,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, quoteDisplayCosts: value });
        }
      }
    },
    {
      key: "quote_dueDate",
      label: RESX.DateTime.DueDate,
      render: () => <DaysAfterDateText days={props.instruction.quoteDefaultDuration} type="send" />,
      inPageEdit: {
        render: ({ onChange, value, cancel }) => <DaysAfterDateInput
          value={value}
          onChange={onChange}
          maxValue={serverReference.constants.document.maxDueDateInterval}
          type="send"
          onEnter={v => onChange(v, true)}
          onEsc={cancel}
        />,
        type: "confirmOrCancelButton",
        initialValue: props.instruction.quoteDefaultDuration,
        submitChange: (value: number) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, quoteDefaultDuration: value });
        }
      }
    }]
  }
}